module.exports = __webpack_public_path__ + "static/media/Brikitt.39c6b842.png";